module.exports = __webpack_public_path__ + "img/stop_btn.0ce5dfe0.png";